import { DOWNLOAD_PATH } from '@/config/myvpnbookSite'

export const homeHero = {
	label: 'MYVPNBOOK',
	title: 'Free VPN for Private and Secure Browsing',
	description:
		'MyVPNBook helps you browse more privately and securely. Protect your connection, hide your IP address, and access the internet with greater confidence wherever you are.',
	points: [
		{ title: 'Free Service', desc: 'Simple access to VPN protection.', icon: 'shield' },
		{ title: 'Secure Connection', desc: 'Help protect your internet traffic.', icon: 'lock' },
		{ title: 'Multiple Devices', desc: 'Use VPN across supported devices.', icon: 'devices' },
		{ title: 'Global Servers', desc: 'Connect through servers in different locations.', icon: 'globe' },
	],
	ctaLabel: 'Get Free VPN',
	ctaTo: DOWNLOAD_PATH,
}

export const everydayFeatures = {
	title: 'Free VPN for Everyday Browsing',
	intro:
		"Enjoy a more private and secure internet experience with MyVPNBook. Whether you're browsing at home, using public Wi-Fi, or connecting from another location, a VPN can help protect your connection and improve your online privacy.",
	items: [
		{
			title: 'Hide Your IP Address',
			desc: 'Help keep your real IP address more private while browsing online.',
			icon: 'ip-mask',
		},
		{
			title: 'Secure Your Connection',
			desc: 'Add an extra layer of protection to your internet connection.',
			icon: 'tunnel-lock',
		},
		{
			title: 'Browse on Public Wi-Fi',
			desc: 'Stay better protected when using public or shared Wi-Fi networks.',
			icon: 'wifi-shield',
		},
		{
			title: 'Access More Websites',
			desc: 'Connect through VPN servers in different locations.',
			icon: 'globe-pin',
		},
		{
			title: 'Protect Your Data',
			desc: 'Help keep your internet traffic more secure while connected.',
			icon: 'data-shield',
		},
	],
}

export const locationIntro = {
	title: 'MyVPNBook VPN Locations',
	lead: 'VPNBook VPN offers some of the fastest free VPN servers with premium connectivity and speeds with more locations being added regularly.',
	points: [
		'100% Forever Free VPN that feels like a paid VPN',
		'Advanced stealth protocols built-in',
		'Lightning fast worldwide server locations',
		'New server locations added frequently',
	],
}

export const serverLocations = [
	{ name: 'USA', code: 'us', path: '/locations/free-usa-vpn/' },
	{ name: 'Russia', code: 'ru', path: '/locations/free-russia-vpn/' },
	{ name: 'South Korea', code: 'kr', path: '/locations/free-korea-vpn/' },
	{ name: 'India', code: 'in', path: '/locations/free-india-vpn/' },
	{ name: 'Japan', code: 'jp', path: '/locations/free-japan-vpn/' },
	{ name: 'Mexico', code: 'mx', path: '/locations/free-mexico-vpn/' },
]

export const deviceIntro = {
	title: 'VPN Apps and Supported Devices',
	lead: 'Use MyVPNBook on your preferred device. Our VPN guides and supported connection options help you get online across different platforms.',
}

export const deviceCards = [
	{
		label: 'VPN for Android',
		desc: 'Connect and browse securely on Android devices.',
		to: '/vpn-for-android/',
		icon: 'android',
	},
	{
		label: 'VPN for Windows',
		desc: 'Set up a VPN connection on your Windows computer.',
		to: '/vpn-for-windows/',
		icon: 'windows',
	},
	{
		label: 'VPN for iPhone & iPad',
		desc: 'Learn how to connect to a VPN on iOS devices.',
		to: '/vpn-for-iphone-ipad/',
		icon: 'apple',
	},
	{
		label: 'VPN for Mac',
		desc: 'Get VPN setup guidance for your Mac.',
		to: '/vpn-for-mac/',
		icon: 'mac',
	},
	{
		label: 'VPN for Chrome',
		desc: 'Browse with additional privacy and connection options.',
		to: '/vpn-for-chrome/',
		icon: 'chrome',
	},
]

export const protocolIntro = {
	title: 'Choose a VPN Protocol',
	lead: 'Different VPN protocols offer different balances of speed, security, and compatibility. Choose the option that works best for your device and connection.',
}

export const protocols = [
	{
		title: 'WireGuard',
		desc: 'Fast, modern, and designed for a simple and efficient VPN connection.',
		tone: 'red',
	},
	{
		title: 'OpenVPN',
		desc: 'A reliable protocol with broad compatibility across many devices.',
		tone: 'orange',
	},
	{
		title: 'IKEv2',
		desc: 'A strong option for mobile users and stable connections.',
		tone: 'blue',
	},
]

export const howItWorksIntro =
	'Getting connected is simple. Follow a few basic steps to start using a VPN connection.'

export const howItWorks = [
	{ step: '1', title: 'Connect', desc: 'Choose a VPN setup option and connect your device.' },
	{ step: '2', title: 'Encrypt', desc: 'Your internet traffic is routed through an encrypted VPN connection.' },
	{ step: '3', title: 'VPN Server', desc: 'Your connection passes through the VPN server you selected.' },
	{ step: '4', title: 'Browse', desc: 'Continue browsing the internet with additional privacy and security.' },
]

export const problemIntro = {
	title: 'Common VPN Problems',
	lead: 'VPN not working as expected? Check the most common connection problems and follow simple fixes for each issue.',
	moreLabel: 'View All Fixed',
	moreTo: '/common-vpn-problems/',
}

export const problemCards = [
	{
		title: "VPN Won't Connect",
		desc: "Can't establish a VPN connection? Check your server, network, permissions, and VPN settings.",
		to: '/common-vpn-problems/#wont-connect',
		icon: 'wifi-off',
	},
	{
		title: 'VPN Is Slow',
		desc: 'A slow VPN connection can be caused by server distance, network congestion, or your current VPN settings.',
		to: '/common-vpn-problems/#slow',
		icon: 'slow',
	},
	{
		title: 'Keeps Disconnecting',
		desc: 'If your VPN repeatedly drops the connection, check your network, battery settings, and VPN app configuration.',
		to: '/common-vpn-problems/#disconnect',
		icon: 'refresh',
	},
	{
		title: "Doesn't Work on Wi-Fi",
		desc: 'Having trouble using a VPN over Wi-Fi? Check the network, router settings, and possible connection restrictions.',
		to: '/common-vpn-problems/#wifi',
		icon: 'wifi',
	},
	{
		title: 'Connection Failed',
		desc: 'Getting a connection error? Check your internet connection, try another server, and review your VPN settings.',
		to: '/common-vpn-problems/#failed',
		icon: 'alert',
	},
]

export const guideIntro = {
	title: 'VPN Guides',
	lead: 'Straightforward answers to common VPN questions about privacy, security, IP addresses, compatibility, and settings.',
	moreLabel: 'View All Guides',
	moreTo: '/guides/',
}

export const guidePreviews = [
	{
		title: 'Can a VPN Hide Your IP Address?',
		desc: 'Find out how a VPN hides your IP address and what websites can see when you connect.',
		path: '/can-vpn-hide-ip-address/',
		date: 'Sep 14, 2026',
	},
	{
		title: 'Does a VPN Protect You on Public Wi-Fi?',
		desc: 'See how a VPN can add protection when using public Wi-Fi and what you should still watch out for.',
		path: '/vpn-public-wifi-security/',
		date: 'Sep 14, 2026',
	},
	{
		title: 'Why Does My IP Address Change When Using a VPN?',
		desc: 'Find out why your IP address changes with a VPN and what the new IP address means.',
		path: '/why-vpn-changes-ip-address/',
		date: 'Sep 14, 2026',
	},
	{
		title: 'Is VPNBook Safe to Use?',
		desc: 'See how VPNBook works and what to consider before using a free VPN service.',
		path: '/is-vpnbook-safe-to-use/',
		date: 'Sep 14, 2026',
	},
	{
		title: 'How to Change Your Password in a VPN Client',
		desc: 'Follow the basic steps to update your VPN password and reconnect your VPN client.',
		path: '/how-to-change-password-vpn-client/',
		date: 'Sep 14, 2026',
	},
	{
		title: 'Can VPNBook Run on Nokia 3?',
		desc: 'Check VPNBook compatibility with Nokia 3, including Android requirements and setup options.',
		path: '/vpnbook-nokia-3/',
		date: 'Sep 14, 2026',
	},
]

export const faqIntro = 'Get quick answers about VPNBook, its servers, accounts, and how the service works.'

export const homeFaqs = [
	{
		q: 'Is VPNBook Free?',
		a: 'Yes, VPNBook provides free VPN access without requiring a paid subscription for its free VPN service. Users can connect through available VPN servers using the supported connection methods.',
	},
	{
		q: 'What is VPNBook?',
		a: 'VPNBook is a VPN service that provides VPN server information and connection options for users who want to route their internet traffic through a VPN server.',
	},
	{
		q: 'Does VPNBook require an account?',
		a: 'VPNBook connection methods may not require the same type of account as a typical subscription-based VPN app. The credentials and setup requirements depend on the connection method you use.',
	},
	{
		q: 'Does VPNBook have a password?',
		a: 'Some VPNBook connection methods use credentials to authenticate the connection. Check the current VPNBook server information and connection details before setting up a server.',
	},
	{
		q: 'Where can I find VPNBook server information?',
		a: 'VPNBook provides server and connection information for its available VPN locations. You can also check our VPN Servers page for more information about VPN server locations and connections.',
	},
	{
		q: 'Can VPNBook be used without installing an app?',
		a: 'Depending on the connection method, a VPN can sometimes be configured directly through the operating system instead of using a dedicated VPN application. The available options depend on your device and the VPN protocol.',
	},
	{
		q: 'Does VPNBook work on older devices?',
		a: "VPN compatibility depends on the device's operating system, supported VPN protocols, and connection method. Older devices may have fewer compatible options than newer systems.",
	},
	{
		q: 'Can VPNBook be used on Nokia phones?',
		a: 'VPNBook may work on a Nokia phone, but compatibility depends on the Android version and the VPN connection method being used.',
	},
]
